module.exports = __webpack_public_path__ + "static/media/triasha-roy.2be8d7b0.jpeg";